import { useTranslation } from 'react-i18next';

const UnauthorizedLayoutSummitBanner = () => {
  const { t, ready } = useTranslation('translation', {
    lng: 'ru',
    useSuspense: false,
  });

  if (!ready) return null;

  return (
    <div className="flex flex-col items-center gap-[2.4rem] w-full max-w-[32.7rem] mx-auto md:max-w-[60.4rem]">
      <h2 className="text-center headline0">
        {t('authPages.summitBanner.title')} <br className="hidden md:inline" />
        {t('authPages.summitBanner.subtitle')}
      </h2>
      <p className="text-center p4 text-secondary">
        {t('authPages.summitBanner.text')}
      </p>
      <img
        src="/assets/summit-banner-mobile-ru.png"
        className="w-[27.7rem] md:hidden"
        alt="FREE2EX"
      />
      <img
        src="/assets/summit-banner-desktop-ru.png"
        className="hidden md:block w-full"
        alt="FREE2EX"
      />
    </div>
  );
};

export { UnauthorizedLayoutSummitBanner };
